<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    import themeConfig from 'config/theme'
    import axios from 'axios'

    export default {
        watch: {
            '$store.state.theme'(val) {
                this.toggleClassInBody(val);
            }
        },
        methods: {
            toggleClassInBody(className) {
                if (className == 'dark') {
                    if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
                    document.body.classList.add('theme-dark');
                } else if (className == 'semi-dark') {
                    if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
                    document.body.classList.add('theme-semi-dark');
                } else {
                    if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
                    if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
                }
            },
            loadBalance() {
                const user = this.$auth.user();
                if (user.email) {
                    this.axios.get('balance')
                    .then((response) => {
                        user.balance = response.data.balance;
                        user.usedBalance = response.data.usedBalance;
                        user.payoutBalance = response.data.payoutBalance;
                        // localStorage['usedBalance'] = response.data.usedBalance; 
                    })
                    .catch((err) => {
                        console.error(err);
                    });
                }
            }
        },
        mounted() {
            this.toggleClassInBody(themeConfig.theme);

            this.loadBalance();

            setInterval(
                function () {
                    this.loadBalance();
                }.bind(this), 40000); 
        }
    }
</script>
